module.exports = __webpack_public_path__ + "img/Rateio_Indireto_Login.dc521f13.png";